import type { MedicoPipelineItem } from "@/api/db/medico";
import { ConfirmationDialog } from "@/components/ui/confirmation-dialog";
import { useMedicoPartialUnlink } from "@/hooks/use-medico";
import { format } from "@/lib/format";
import { MedicoLabels } from "@/lib/labels/medico";

function PartRow({ part }: { part: MedicoPipelineItem["parts"][number] }) {
	const partialUnlink = useMedicoPartialUnlink();

	return (
		<li
			data-slot="part"
			data-transcript={part.transcriptId}
			className="flex flex-wrap items-center gap-2 border-b border-border/60 py-1.5 last:border-b-0"
		>
			<span className="min-w-0 flex-1 truncate font-mono text-xs text-foreground/70">
				{part.title}
			</span>

			<span className="font-mono text-xs text-muted-foreground">
				{format.dateTime(part.recordedAt)}
			</span>

			<ConfirmationDialog
				slot="remove-part-trigger"
				tone="destructive"
				title={MedicoLabels.pipeline.removePartConfirm}
				pendingLabel={MedicoLabels.pipeline.removingPart}
				isPending={partialUnlink.isPending}
				onConfirm={() => partialUnlink.mutate({ transcriptId: part.transcriptId })}
				className="text-xs font-medium text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
			>
				{MedicoLabels.pipeline.removePart}
			</ConfirmationDialog>
		</li>
	);
}

export function PipelineParts({ item }: { item: MedicoPipelineItem }) {
	return (
		<div data-slot="parts" className="flex flex-col gap-1 border-t border-border/60 pt-2">
			<p className="text-xs font-medium text-muted-foreground">
				{MedicoLabels.pipeline.partsTitle}
			</p>

			<ul className="flex flex-col">
				{item.parts.map((part) => (
					<PartRow key={part.transcriptId} part={part} />
				))}
			</ul>
		</div>
	);
}
